import React from 'react';

import { CommonPropTypes } from '../Icons.types';

const Play: React.FC<CommonPropTypes> = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width='116'
      height='116'
      viewBox='0 0 116 116'
      fill='none'
    >
      <path
        opacity='0.9'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M58 116C90.0325 116 116 90.0325 116 58C116 25.9675 90.0325 0 58 0C25.9675 0 0 25.9675 0 58C0 90.0325 25.9675 116 58 116ZM41.8889 85.9053L90.2222 58L41.8889 30.0947L41.8889 85.9053Z'
        fill='white'
        fill-opacity='0.6'
      />
    </svg>
  );
};

export default Play;
